import React, { useContext, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import TemplateDataContext from "../../../Contexts/TemplateData.context";
import { ERR_BAD_REQUEST, templateActionEnum, USER_EXIST, USER_ISSUE } from "../../../Config/Constants";
import { APP_NAVIGATION, ROUTE_CONSTANT } from "../../../Util/Constants";
import "./SaveDocumentModal.css";
import { createCookie, DeleteTemplateDocId, getPortalCD, GetTemplateDocId, PerquisiteBountyEnable, readCookie, redirectToPMSAndExistPlanPage, setIPConfig, saveDocIds } from "../../../Util/helper";
import { appDomain, defaultCountryCode, defaultCurrencyCode, getFacebookClientId, getGoogleClientId, getTenantGroupId, getTenantId } from "../../../Util/general-config";
import EventService from "../../../Services/EventService";
import { UserActionEnum } from "../../../Config/UserType";
import DocBuilderService from "../../../Services/DocBuilderService";
import { validateSignupEmail, validateUserPassword } from "../../../Validators/GenericValidator";
import UserServiceApi from "../../../Services/UserService";
import AuthServiceApi from "../../../Services/AuthService";
import { v4 as UUID4 } from "uuid";
import { GoogleOAuthProvider, useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import FacebookLogin from "react-facebook-login";
import { goToDashboardAfterDownload } from "../../../Util/DownloadHelper";
import PathHelper from "../../../Util/PathHelper";
import ReactLoader from "../Loader/Loader";
import UserDataContext from "../../../Contexts/User.context";



type SaveDocumentModalProps = { onClose?: () => void ,callBackDocIdHandler?: () => void};

const SaveDocumentModalContent: React.FC<SaveDocumentModalProps> = ({ onClose, callBackDocIdHandler }) => {
  // const { state, dispatch } = useContext(TemplateDataContext);
  const { state, dispatch: templateDispatch } = useContext(TemplateDataContext);
  const userContext = useContext(UserDataContext);
  const userDispatch = userContext?.dispatch;
  const { showSaveDocumentModal } = state;
  const [showLoader, setShowLoader] = useState("d-none");
  const [emailId, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [emailErrorMsg, setEmailErrorMsg] = useState("");
  const [passwordError, setPasswordError] = useState(false);
  const [passwordErrorMsg, setPasswordErrorMsg] = useState("");
  const [disableBtn, setdisableBtn] = useState(false);
  const [loginError, setLoginError] = useState(false);
  const [loginErrorMessage, setLoginErrorMessage] = useState("");
  const { state: templateState } = useContext(TemplateDataContext);
  const { templatePath, selectedState, templates } = templateState;
  const [resError, setResError] = useState("");
  const [openSignUp, setOpenSignUp] = useState(true);
  const queryParams = new URLSearchParams(window.location.search);

  const navigate = useNavigate();
  const RedirectPath = PathHelper(APP_NAVIGATION.SINU);

  useEffect(() => {
     const docid = readCookie("docid");
    if(!docid){
      callBackDocIdHandler?.();
    }
  }, [showSaveDocumentModal]);

  const handleClose = () => {
    templateDispatch({
      type: templateActionEnum.SET_SAVE_DOCUMENT_MODAL_STATE,
      payload: false,
    });
    onClose && onClose();
  };

    // Text constants
  const saveDocModalText = {
    title: openSignUp ? `Don’t lose your progress` : "Don't lose your progress",
    subtitle: openSignUp
      ? "Save your work by adding an email address so you can come back later"
      :  <>Save your work by login so you <br />  can come back later</>,
    signupText: openSignUp ? "Unlimited downloads, shares and printing" : "",
    google: openSignUp ? "Sign up with Google" : "Sign in with Google",
    apple: openSignUp ? "Sign up with Apple" : "Sign in with Apple",
    primaryButton: "Save my document",
    memberLink: openSignUp ? "Login" : "Sign up"
  };


    const responseFacebook = (response: any) => {
      //const typeofdoc = docType === DOC_TYPE.COVER_LETTER ? TYPE_OF_DOC.COVER_LETTER : TYPE_OF_DOC.RESUME;
      console.log(response);
      if (!!response && response.status != "unknown") {
        setShowLoader("d-block");
        setPasswordError(false);
        const { name, email, id } = response;
        const externalData = {
          createUser: {
            countryCD: setIPConfig("countryCode"),
            currencyCD: setIPConfig("currency"),
            portalCD: getPortalCD(),
            parentUserGuid: "",
            firstName: name,
            lastName: "",
            company: "",
            title: "",
            email: email,
            password: "",
            tenantId: getTenantId(),
            tenantGroupId: getTenantGroupId(),
          },
          externalLoginInfo: {
            loginType: 1,
            providerKey: id, // "100732998798818",
          },
        };
        UserServiceApi.createExternalUser(externalData).then((response: any) => {
          if (response) {
            const authData = {
              Username: email.trim(),
              UserGuid: response.userGuid,
              Email: email.trim(),
            };
            createCookie("userguid", response.userGuid, 1);
            AuthServiceApi.AuthenticateUser(authData).then((authResponse: any) => {
              const { jwtToken, refreshToken, expiresAt, legacyToken } = authResponse;
              localStorage.setItem("jwtToken", jwtToken);
              localStorage.setItem("refreshToken", refreshToken);
              localStorage.setItem("expiresAt", expiresAt);
              createCookie("jwtToken", jwtToken, 1);
              createCookie("refreshToken", refreshToken, 1);
              createCookie("expiresAt", expiresAt, 1);
              createCookie("legacyTicket", legacyToken, 1);

              window.registerUser(email.trim());
              let data = {
                Id: UUID4(),
                UserId: response.userGuid,
                VisitorId: readCookie("visitorGuid"),
                VisitId: readCookie("visitGuid"),
              };
              EventService.EventPost(data, "user", "login", "user").then((response) => {});
              userDispatch({
                type: UserActionEnum.SET_USERINFO,
                payload: { userGUID: response.userGuid, email: email.trim() },
              });
              const docid = readCookie("docid");
              if (docid) {
              let templateIdToSave = templatePath;
              saveDocIds(templateIdToSave, docid);
                DocBuilderService.updateUserGuid(docid, response.userGuid).then((updateResponse: any) => {
                  console.log("doc updated");
                  DeleteTemplateDocId(templatePath, false);
                });
              }
              const userAddressObj = {
                UserGuid: response.userGuid,
                City: setIPConfig("city"),
                State: setIPConfig("region"),
                Country: setIPConfig("country"),
                ZipCode: setIPConfig("zip"),
                AddressType: 0,
                IsActive: 1,
                TenantId: getTenantId(),
              };
              UserServiceApi.saveUserAddress(userAddressObj).then((res: any) => {});
              UserServiceApi.getUserObject().then((response: any) => {
               setShowLoader("d-none");
                handleClose();
              });
            });
          } else {
            //dispatch(savePersonalInfoFailure(response.data));
          }
        });
      } else {
        console.log("login error..");
      }
    };

  const handleSaveDocument = () => {
    if (openSignUp) {
      // Signup flow
      const isValid = validateData();
      if (isValid) {
        setShowLoader("d-block");
        // setdisableBtn(true);
        const params = {
          email: emailId.trim(),
          password: pwd.trim(),
          portalCD: getPortalCD(),
          tenantId: getTenantId(),
          countryCD: setIPConfig("countryCode", defaultCountryCode),
          currencyCD: setIPConfig("currency", defaultCurrencyCode),
          tenantGroupId: getTenantGroupId(),
        };
       setShowLoader("d-block");

        UserServiceApi.createUser(params)
          .then((resp: any) => {
            if (resp.isValid) {
              setShowLoader("d-none");
              handleClose();

          const authData = {
          Username: params.email.trim(),
          UserGuid: resp.userGuid,
          Email: params.email.trim(),
     };

         createCookie("userguid", resp.userGuid, 1);
        AuthServiceApi.AuthenticateUser(authData)
          .then((authResponse: any) => {
            const { jwtToken, refreshToken, expiresAt, ssoToken, legacyToken } = authResponse;
            localStorage.setItem("jwtToken", jwtToken);
            localStorage.setItem("refreshToken", refreshToken);
            localStorage.setItem("expiresAt", expiresAt);
            createCookie("jwtToken", jwtToken, 1);
            createCookie("refreshToken", refreshToken, 1);
            createCookie("expiresAt", expiresAt, 1);
            createCookie("ssoauth", "1");
            createCookie("ssoToken", ssoToken, 1);
            createCookie("legacyTicket", legacyToken, 1);

            window.registerUser(emailId.trim());
                        let data = {
                          Id: UUID4(),
                          UserId: resp.userGuid,
                          VisitorId: readCookie("visitorGuid"),
                          VisitId: readCookie("visitGuid"),
                        };
                        EventService.EventPost(data, "user", "login", "user").then((response) => {});
                        userDispatch({
                          type: UserActionEnum.SET_USERINFO,
                          payload: { userGUID: resp.userGuid, email: emailId.trim() },
                        });
            const docid = readCookie("docid");
            if (docid) {
              DocBuilderService.updateUserGuid(docid, resp.userGuid).then((updateResponse: any) => {
                console.log("doc updated");
                DeleteTemplateDocId(templatePath, false);
               setdisableBtn(false);
              });
            } else {
              // setdisableBtn(false);
              // handleClose();
            }
            setShowLoader("d-none");

            var userAddressObj = {
              UserGuid: resp.userGuid,
              City: setIPConfig("city"),
              State: setIPConfig("region"),
              Country: setIPConfig("country"),
              ZipCode: setIPConfig("zip"),
              AddressType: 0,
              IsActive: 1,
              TenantId: getTenantId(),
            };
            UserServiceApi.saveUserAddress(userAddressObj).then((res: any) => {});

          })
          .catch((error: unknown) => {
            setdisableBtn(false);
            setShowLoader("d-none");
          });

            } else {
              console.log("Invalid Crendetials");
              console.log(resp.error);

              if (resp.error === USER_EXIST || resp.error === USER_ISSUE) {
          setResError("Shoot! Email is already taken.Try another.");
              }
              setdisableBtn(false);
              setShowLoader("d-none");
            }
          })
          .catch((error: unknown) => {
            console.log("Error", error);
            setdisableBtn(false);
            setShowLoader("d-none");
          });

      }
    }
    else    {
      // Login flow
    const isValid = validateData();
    if (isValid) {
      setShowLoader("d-block");
      const params = {
        username: emailId.trim(),
        password: pwd.trim(),
        tenantGroupId: getTenantGroupId(),
      };
      const signinResponse = AuthServiceApi.LoginUser(params)
        .then((resp: any) => {
          const { jwtToken, refreshToken, expiresAt, ssoToken, legacyToken } = resp;
          localStorage.setItem("jwtToken", jwtToken);
          localStorage.setItem("refreshToken", refreshToken);
          localStorage.setItem("expiresAt", expiresAt);
          createCookie("jwtToken", jwtToken, 1);
          createCookie("refreshToken", refreshToken, 1);
          createCookie("expiresAt", expiresAt, 1);
          createCookie("ssoauth", "1");
          createCookie("ssoToken", ssoToken, 1);
          createCookie("legacyTicket", legacyToken, 1);
          setdisableBtn(false);
          return UserServiceApi.getUserByUserName(encodeURIComponent(params.username))
            .then((userResponse: any) => {
              if (userResponse) {
                const { userGuid, isMigrated } = userResponse;
                var validUserGuid = userGuid;
                if (userGuid.includes("-") == false) {
                  validUserGuid = userGuid.replace(/(.{8})(.{4})(.{4})(.{4})(.{12})/, "$1-$2-$3-$4-$5");
                }
                createCookie("userguid", validUserGuid, 1);
                let data = {
                  Id: UUID4(),
                  UserId: validUserGuid,
                  VisitorId: readCookie("visitorGuid"),
                  VisitId: readCookie("visitGuid"),
                };
                EventService.EventPost(data, "user", "login", "user").then((response) => {
                  //console.log("data posted", data, response);
                });

                userDispatch({
                  type: UserActionEnum.SET_USERINFO,
                  payload: { userGUID: validUserGuid, email: userResponse.username },
                });
                let docid: string = "";
                GetTemplateDocId(templatePath).then((value) => {
                  if (value) {
                    docid = value;
                    let templateIdToSave = templatePath;
                    saveDocIds(templateIdToSave, docid);
                    DocBuilderService.updateUserGuid(docid, validUserGuid).then((updateResponse: any) => {
                      console.log("doc updated");
                      // DeleteTemplateDocId(templatePath, false);

                      UserServiceApi.getUserProfileAbridged(validUserGuid).then((userProfileResponse: any) => {
                         setShowLoader("d-none");
                          handleClose();
                      });
                    });
                  } else {
                    // NOTE ::: If local env then redirect on home page else on dashboard.
                    if (`${process.env.REACT_APP_ENVIRONMENT}` == "DEVELOPMENT") {
                      navigate(ROUTE_CONSTANT.HOME);
                    } else {
                      console.log("to dashboard!!");
                      window.location.href = appDomain() + ROUTE_CONSTANT.USER_DASHBOARD;
                      setShowLoader("d-none");
                    }
                  }
                });
              }
            })
            .catch((err: any) => {
              setShowLoader("d-none");
            });
        })
        .catch((err: any) => {
          // TO DO :: Display Invalid User message.
          console.log("Invalid Crendetials");
          if (err.code == ERR_BAD_REQUEST) {
            setPasswordError(true);
            setPasswordErrorMsg("Invalid Email or password.");
          }
          setShowLoader("d-none");
          if (err.isAxiosError) {
            setdisableBtn(false);
          }
        });
    }
    // handleClose();
    }
  };

   const onEmailChangeHandler = (e: { target: { value: any } }) => {
      const {
        target: { value },
      } = e;
      setEmail(value);
    };
    const onPwdChangeHandler = (e: { target: { value: any } }) => {
      const {
        target: { value },
      } = e;
      setPwd(value);
    };
    const validateData = () => {
      setEmailError(false);
      setPasswordError(false);
      let errors = 0;
      if (emailId.trim() === "" && pwd.trim() === "") {
        setResError("Email and Password are required");
      } else {
        const emailValidator = validateSignupEmail(emailId.trim());
        if (emailValidator.isValid === false) {
          ++errors;
          setEmailError(true);
          setResError("");
          setEmailErrorMsg(emailValidator.errorMessage);
          console.log("emailValidator.errorMessage----", emailValidator.errorMessage);
        }
        const passwordValidator = validateUserPassword(pwd);
        if (passwordValidator.isValid === false) {
          ++errors;
          setPasswordError(true);
          setResError("");
          setPasswordErrorMsg(passwordValidator.errorMessage);
        }
        if (errors > 0) {
          ++errors;
          setdisableBtn(false);
          return false;
        } else {
          setdisableBtn(true);
          return true;
        }
      }
    };

      const NavigateToPaymentMS = () => {
        let isNavigateToExistingPlanPage = redirectToPMSAndExistPlanPage();
        if (isNavigateToExistingPlanPage) {
          // navigate(RedirectPath.next);
          navigate("");
        }
      };

  const openSignInInNewTabAndCloseModal = () => {
    window.open(ROUTE_CONSTANT.SIGNIN, "_blank");
    handleClose();
  };

  const redirectToSignInAndCloseModal = () => {
      setOpenSignUp(!openSignUp);
      // Clear form fields when switching modes
      setEmail("");
      setPwd("");
      // Clear any validation errors
      setEmailError(false);
      setPasswordError(false);
      setEmailErrorMsg("");
      setPasswordErrorMsg("");
      setResError("");
    // navigate(ROUTE_CONSTANT.SIGNIN);
    // handleClose();
  };

    const NavigateToHomeForAuth = () => {
      if (!!readCookie("jwtToken") || !!readCookie("refreshToken")) {
        goToDashboardAfterDownload(true);
        //navigate(ROUTE_CONSTANT.HOME);
      }
    };


  const responseGoogle = (response: any, accessToken: any) => {
    if (!!response && !!accessToken) {
      setShowLoader("d-block");
      setPasswordError(false);
      console.log(response);
      const { email, id } = response;
      const externalData = {
        createUser: {
          countryCD: setIPConfig("countryCode"),
          currencyCD: setIPConfig("currency"),
          portalCD: getPortalCD(),
          parentUserGuid: "",
          firstName: "",
          lastName: "",
          company: "",
          title: "",
          email: email,
          password: "",
          tenantId: getTenantId(),
          tenantGroupId: getTenantGroupId(),
        },
        externalLoginInfo: {
          loginType: 2,
          providerKey: id, // "100732998798818",
        },
      };
      UserServiceApi.createExternalUser(externalData).then((response: any) => {
        if (response) {
          const authData = {
            Username: email.trim(),
            UserGuid: response.userGuid,
            Email: email.trim(),
          };
          createCookie("userguid", response.userGuid, 1);
          AuthServiceApi.AuthenticateUser(authData).then((authResponse: any) => {
            const { jwtToken, refreshToken, expiresAt, legacyToken } = authResponse;
            localStorage.setItem("jwtToken", jwtToken);
            localStorage.setItem("refreshToken", refreshToken);
            localStorage.setItem("expiresAt", expiresAt);
            createCookie("jwtToken", jwtToken, 1);
            createCookie("refreshToken", refreshToken, 1);
            createCookie("expiresAt", expiresAt, 1);
            createCookie("legacyTicket", legacyToken, 1);

            window.registerUser(email.trim());
            let data = {
              Id: UUID4(),
              UserId: response.userGuid,
              VisitorId: readCookie("visitorGuid"),
              VisitId: readCookie("visitGuid"),
            };
            EventService.EventPost(data, "user", "login", "user").then((response) => {});
            userDispatch({
              type: UserActionEnum.SET_USERINFO,
              payload: { userGUID: response.userGuid, email: email.trim() },
            });
            const docid = readCookie("docid");
            if (docid) {
              let templateIdToSave = templatePath;
              saveDocIds(templateIdToSave, docid);
              DocBuilderService.updateUserGuid(docid, response.userGuid).then((updateResponse: any) => {
                console.log("doc updated");
                // DeleteTemplateDocId(templatePath, false);
              });
            }
            const userAddressObj = {
              UserGuid: response.userGuid,
              City: setIPConfig("city"),
              State: setIPConfig("region"),
              Country: setIPConfig("country"),
              ZipCode: setIPConfig("zip"),
              AddressType: 0,
              IsActive: 1,
              TenantId: getTenantId(),
            };
            UserServiceApi.saveUserAddress(userAddressObj).then((res: any) => {});
            UserServiceApi.getUserObject().then((response: any) => {
              setShowLoader("d-none");
              handleClose();
            });
          });
        } else {
          //dispatch(savePersonalInfoFailure(response.data));
        }
      });
    } else {
      console.log("Invalid cred..");
    }
  };

    const GoogleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      if (!!tokenResponse) {
        const userInfo = await axios
          .get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${tokenResponse.access_token}`, {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
            },
          })
          .then((res) => {
            console.log(res);
            responseGoogle(res.data, tokenResponse.access_token);
          });
      } else {
        console.log("Failed to login with google 1");
        // setLoginError(true);
        // setLoginErrorMessage("Failed to login with google");
      }
    },

    onError: () => {
      console.log();
      console.log("Failed to login with google 2");
      // setLoginError(true);
      // setLoginErrorMessage("Failed to login with google");
    },
  });


  return (
    <>
      <ReactLoader loaderProps={{ showloader: showLoader }} />
      <Modal
        className="save-document-modal"
        show={showSaveDocumentModal}
        onHide={handleClose}
        centered
        backdrop
        keyboard
        backdropClassName="save-document-modal-backdrop"
        id="save-document-modal"
      >
        <button className="close-btn" onClick={() => handleClose()}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="icon"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        <Modal.Body className="save-document-modal-body">
          {/* Titles */}
          <div className="sdm-title-wrap">
            <div className="sdm-title">
              Don't lose your
              <br /> progress
            </div>
            <div className="sdm-subtitle">{saveDocModalText.subtitle}</div>
            {/* <p className="sdm-signuptext">{saveDocModalText.signupText}</p> */}
          </div>
          <div className="sdm-signup">
            {/* Social row + apple below */}
            <div className="sdm-social-grid">
              {/* Google composite */}
              <button
                type="button"
                className="sdm-google"
                // onClick={openSignInInNewTabAndCloseModal}
                onClick={() => GoogleLogin()}
                aria-label="Sign up with Google"
                id="sdm-google-btn"
              >
                <span className="sdm-google__icon" aria-hidden="true">
                  {/* Google G */}
                  <svg viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_g)">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10.5 4.605c1.878 0 3.145.811 3.867 1.489L17.189 3.338C15.456 1.727 13.2.738 10.5.738 6.589.738 3.211 2.983 1.567 6.249l3.233 2.511C5.611 6.349 7.856 4.605 10.5 4.605Z"
                        fill="#EA4335"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M20.1 10.961c0-.822-.067-1.422-.211-2.044H10.5v3.711h5.511c-.111.922-.711 2.311-2.044 3.244l3.155 2.444C19.011 16.572 20.1 14.005 20.1 10.961Z"
                        fill="#4285F4"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.811 12.716a6.9 6.9 0 0 1-.333-1.978c0-.689.122-1.356.322-1.978L1.567 6.25C.866 7.642.501 9.18.5 10.738c0 1.611.389 3.133 1.067 4.489l3.244-2.511Z"
                        fill="#FBBC05"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10.5 20.738c2.7 0 4.967-.889 6.622-2.422l-3.155-2.444c-.844.589-1.978 1-3.467 1-2.644 0-4.889-1.744-5.689-4.155L1.578 15.227c1.644 3.267 5.011 5.511 8.922 5.511Z"
                        fill="#34A853"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_g">
                        <rect width="20" height="20" fill="#fff" transform="translate(.5 .738)" />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                <span className="sdm-google__slab">{saveDocModalText.google}</span>
              </button>

              <div id="sdm-facebook-btn" className="sdm-fb-wrapper">
                <FacebookLogin
                  appId={getFacebookClientId()}
                  fields="name,email,picture"
                  callback={responseFacebook}
                  textButton=""
                  cssClass="sdm-fb"
                  icon={
                    <svg viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                      <path
                        d="M25.396 12.815C25.396 5.869 19.765.238 12.819.238 5.874.238.243 5.869.243 12.815 0 19.092 4.842 24.295 10.854 25.238V16.45H7.661v-3.635h3.193v-2.771c0-3.152 1.878-4.893 4.751-4.893 1.376 0 2.815.245 2.815.491v3.094h-1.586c-1.562 0-2.049.969-2.049 1.964v2.359h3.488l-.557 3.635h-2.93v8.788c6.012-.943 10.611-6.146 10.611-12.422Z"
                        fill="#1877F2"
                      />
                    </svg>
                  }
                />
              </div>

              {/* Apple pill (below, left) */}
              {/* <button
                type="button"
                className="sdm-apple"
                onClick={openSignInInNewTabAndCloseModal}
                aria-label="Sign up with Apple"
                id="sdm-apple-btn"
              >
                <svg viewBox="0 0 21 26" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path
                    d="M20.347 8.762c-.145.112-2.705 1.555-2.705 4.763 0 3.71 3.258 5.023 3.355 5.055-.015.08-.518 1.798-1.718 3.548-1.07 1.54-2.187 3.078-3.887 3.078-1.7 0-2.137-.988-4.1-.988-1.913 0-2.593 1.02-4.148 1.02-1.555 0-2.64-1.425-3.888-3.175C1.81 20.008.642 16.815.642 13.785c0-4.861 3.16-7.439 6.27-7.439 1.653 0 3.03 1.085 4.068 1.085.987 0 2.527-1.15 4.407-1.15 0 0 2.56.065 4.235 2.48ZM14.496 4.224c.778-.923 1.328-2.203 1.328-3.483 0-.178-.015-.358-.047-.503-1.265.048-2.77.843-3.677 1.896-.712.81-1.377 2.09-1.377 3.388 0 .195.033.39.048.453.08.015.21.032.34.032 1.135 0 2.563-.76 3.385-1.783Z"
                    fill="#000"
                  />
                </svg>
                <span>{saveDocModalText.apple}</span>
              </button> */}
            </div>

            {/* Divider */}
            <div className="sdm-divider" role="separator" aria-label="Email sign up divider">
              <div className="sdm-divider__line" />
              <div className="sdm-divider__text">or</div>
              <div className="sdm-divider__line sdm-divider__line--rev" />
            </div>

            {/* Fields */}
            <div className="alert-danger">
              <div className="form-text ">
                {resError && (
                  <span key="pswrdErr">
                    {" "}
                    <span className="text-danger error-style">
                      <small key="resError">{resError}</small>
                    </span>
                  </span>
                )}
                {(emailError || passwordError) && (
                  <p key="pswrdErr" className="alert error signup-error-message error-style text-danger ">
                    {/* <span>error prohibited this user from being saved:</span>
                    <br /> */}
                    {emailError && (
                      <li>
                        <small key="pswrdErr">{emailErrorMsg}</small>
                      </li>
                    )}

                    {passwordError && (
                      <li>
                        <small key="pswrdErrw">{passwordErrorMsg}</small>
                      </li>
                    )}

                    {loginError && (
                      <li>
                        <small key="pswrdErrww">{loginErrorMessage}</small>
                      </li>
                    )}
                  </p>
                )}
              </div>
            </div>
            <div className="sdm-fields">
              <label className="sdm-field">
                <input
                  type="email"
                  id="sdm-email-input"
                  placeholder="Email address"
                  aria-label="Email address"
                  value={emailId} // Elian: added this so input fields would reset when switching between login/signup
                  onChange={onEmailChangeHandler}
                />
              </label>
              <label className="sdm-field">
                <input  
                  id="sdm-password-input" 
                  type="password" 
                  placeholder="Password" 
                  aria-label="Password" 
                  value={pwd} // Elian: added this so input fields would reset when switching between login/signup
                  onChange={onPwdChangeHandler} 
                />
              </label>
            </div>

            {/* Consent */}
            <p className="sdm-consent">
              By continuing, you confirm that you have read and consent to our{" "}
              <a href="/terms/" target="_blank" rel="noopener noreferrer">
                Term of Use
              </a>{" "}
              and{" "}
              <a href="/privacy/" target="_blank" rel="noopener noreferrer">
                Privacy Policy
              </a>
            </p>

            {/* Primary CTA */}
            <button
              type="button"
              className="sdm-primary"
              onClick={handleSaveDocument}
              id={openSignUp ? "sdm-signup-primary-btn" : "sdm-save-primary-btn"}
              data-mode={openSignUp ? "signup" : "login"}
              data-role="sdm-primary-btn"
            >
              {saveDocModalText.primaryButton}
            </button>

            {/* Footer */}
            <div className="sdm-member">
              <span>Already a member? –</span>
              <button
                onClick={redirectToSignInAndCloseModal}
                className="sdm-member__link"
                id={openSignUp ? "sdm-member-login-btn" : "sdm-member-signup-btn"}
              >
                {saveDocModalText.memberLink}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};


// Main component wrapped with GoogleOAuthProvider
const SaveDocumentModal: React.FC<SaveDocumentModalProps> = (props) => {
  return (
    <GoogleOAuthProvider clientId={getGoogleClientId()}>
      <SaveDocumentModalContent {...props} />
    </GoogleOAuthProvider>
  );
};


export default SaveDocumentModal;
